module.exports = __webpack_public_path__ + "media/toolkits/COVIDicon-3-ec6f188e.svg";